export function FormField({
  label,
  name,
  type = 'text',
  value,
  onChange,
  required = false,
  placeholder = '',
  disabled = false,
  readOnly = false,
  min,
  step,
  maxLength,
  className = '',
  children,
  ...rest
}) {
  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-slate-700"
        >
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}

      {children ? (
        children
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          value={value ?? ''}
          onChange={onChange}
          required={required}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
          min={min ?? (type === 'number' ? '0' : undefined)}
          step={step ?? (type === 'number' ? 'any' : undefined)}
          placeholder={placeholder}
          {...rest}
          className="w-full rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-sm font-normal text-slate-900 shadow-xs transition-colors placeholder:text-slate-400 focus:border-[#080d25] focus:outline-none focus:ring-2 focus:ring-[#080d25]/10 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500"
        />
      )}
    </div>
  )
}
